import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { IconButton } from '@material-ui/core'
import { Phone, MicOff } from '@material-ui/icons'
// import FromNumberDropdown from './FromNumberDropdown'
import { call } from 'actions/inbox'
import { Device } from 'twilio-client'
import { getClientToken, getClientTokenSchema } from 'actions/voice'
import { Link } from 'react-router-dom'
import contactLabel from 'utils/contactLabel'
import secondsToDhms from 'utils/secondsToDhms'

const LogBox = ({ text }) => (
  <div>
    <div style={{ fontSize: 16, minHeight: 19 }}>{text}</div>
  </div>
)

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

Device.on('connect', () => {
  console.log("hits Device.on('connect')")
})

class PhoneCall extends Component {
  state = { onPhone: false, muted: false, time: 0 }

  // TODO: add prod schema
  // componentDidMount() {
  //   // this.props.getClientTokenSchema()

  //   Device.on('connect', () => {
  //     console.log("hits Device.on('connect')")
  //   })
  // }

  componentDidUpdate(prevProps) {
    var self = this
    const {
      token,
      // selectedFromNumber,
      // to,
      // account_id,
      // contact_id,
      // vastUserName,
    } = this.props

    if (token && !jwtToken && self.state.onPhone) {
      Device.setup(token)

      Device.audio.availableOutputDevices.forEach(function (device, id) {
        if (id === 'default') {
          // console.log('hits if')
          Device.audio
            .setInputDevice('default')
            .then(() => console.log('success!'))
        }
        // console.info('Available device:', id, '(labeled', device.label, ')')
      })

      // Device.audio.setInputDevice('default').then(function () {
      //   console.info('Success!')
      // })

      Device.disconnect(function () {
        clearInterval(self.timerID)

        self.setState({
          onPhone: false,
          log: 'Call ended.',
          time: 0,
        })

        // clearInterval(self.timerID)
      })

      Device.ready(function () {
        self.setState({ log: 'Connected' })
      })

      // if (selectedFromNumber && selectedFromNumber.phone_number && to) {
      //   if (account_id && contact_id && vastUserName) {
      //     // const { token } = this.props
      //     const payload = {
      //       number: to,
      //       from_number: selectedFromNumber.phone_number,
      //       account_id,
      //       contact_id,
      //       vastUserName,
      //     }

      //     if (jwtToken) {
      //       window.ReactNativeWebView &&
      //         window.ReactNativeWebView.postMessage(
      //           JSON.stringify({
      //             payload,
      //             token,
      //           }),
      //         )
      //     } else {
      //       Device.connect(payload)
      //     }
      //   }
      //   this.props.call()
      // }
    } /*  else {
      if (!token && !jwtToken && !self.state.onPhone) {
        this.props.getClientToken()
      }
    } */
  }

  // handleToggleMute() {
  //   var muted = !this.state.muted
  //   const activeConnection = Device.activeConnection()

  //   // console.log(activeConnection)
  //   this.setState({ muted: muted })

  //   activeConnection.mute(muted)
  // }

  tick() {
    this.setState({ time: this.state.time + 1 })
  }

  render() {
    const {
      selectedFromNumber,
      to,
      account_id,
      contact_id,
      vastUserName,
      contact,
      // getClientToken,
    } = this.props

    return (
      <div
        style={{
          height: 110,
          // position: 'relative',
        }}
      >
        {/* <div
          style={{
            height: 48,
            backgroundColor: '#f1f1f1',
          }}
        /> */}
        <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
          <Link to="/managephones">Manage phones</Link>
        </div>
        <div
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        ></div>
        <div
          style={{
            margin: '10px auto 0',
            width: '50%',
            textAlign: 'center',
          }}
        >
          {/* {!jwtToken && (
            <div
              style={{
                marginBottom: 10,
              }}
            >
              <FromNumberDropdown />
            </div>
          )} */}
          <div style={{ fontSize: 22, minHeight: 25 }}>
            {this.state.onPhone ? secondsToDhms(this.state.time) : null}
          </div>
          <IconButton
            disabled={!this.state.onPhone}
            onClick={() => {
              this.setState({ muted: !this.state.muted })
              Device.activeConnection().mute(!this.state.muted)
            }}
            style={{
              backgroundColor: this.state.muted ? 'gray' : 'transparent',
              color: this.state.muted ? '#fff' : 'gray',
            }}
          >
            <MicOff />
          </IconButton>
          <IconButton
            onClick={() => {
              if (!this.state.onPhone) {
                if (!jwtToken) {
                  try {
                    Device.destroy()
                  } catch (e) {
                    console.log(e)
                  }
                }

                if (!jwtToken) {
                  this.setState({
                    muted: false,
                    onPhone: true,
                  })
                }

                this.props.getClientToken().then((tokenPayload) => {
                  if (tokenPayload.twilio_token && !jwtToken) {
                    Promise.resolve(
                      Device.setup(tokenPayload.twilio_token),
                    ).then(() => {
                      if (
                        selectedFromNumber &&
                        selectedFromNumber.phone_number &&
                        to
                      ) {
                        if (account_id && contact_id && vastUserName) {
                          // const { token } = this.props
                          const payload = {
                            number: to,
                            from_number: selectedFromNumber.phone_number,
                            account_id,
                            contact_id,
                            vastUserName,
                          }
                          this.timerID = setInterval(() => this.tick(), 1000)
                          Device.connect(payload)
                        }
                        this.props.call()
                      }
                    })
                  } else {
                    window.ReactNativeWebView &&
                      window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                          payload: {
                            number: to,
                            from_number: selectedFromNumber.phone_number,
                            account_id,
                            contact_id,
                            vastUserName,
                          },
                          token: tokenPayload.twilio_token,
                          contactLabel: contactLabel(contact),
                        }),
                      )
                    console.log('no tokenPayload.twilio_token')
                  }
                })
              } else {
                this.setState({ onPhone: false })
                if (!jwtToken) {
                  try {
                    Device.destroy()
                  } catch (e) {
                    console.log(e)
                  }
                }
              }
            }}
            style={{
              backgroundColor: this.state.onPhone ? 'red' : '#19B940',
              color: '#fff',
            }}
          >
            <Phone />
          </IconButton>
          <LogBox text={this.state.log} />
        </div>
        {/* <div style={{ position: 'absolute', bottom: 5, left: 5 }}>
          <LogBox text={this.state.log} />
        </div> */}
      </div>
    )
  }
}

export default connect(
  (state) => ({
    token: state.voice.token,
    to: state.inbox.to.current.value,
    selectedFromNumber: state.inbox.fromNumberSelected,
    account_id:
      state.AccountSettings &&
      state.AccountSettings.settings &&
      state.AccountSettings.settings.id,
    contact_id:
      (state.inbox.contactSelected && state.inbox.contactSelected.id) ||
      state.inbox.conversationSelected,
    contact:
      (state.inbox.contactSelected || state.inbox.conversationSelected) &&
      state.contacts.contactsWithEmailsByID[
        state.inbox.contactSelected || state.inbox.conversationSelected
      ],
    vastUserName:
      state.auth.session &&
      state.auth.session.idToken &&
      state.auth.session.idToken.payload &&
      state.auth.session.idToken.payload['cognito:username'],
  }),
  (dispatch) =>
    bindActionCreators(
      { call, getClientToken, getClientTokenSchema },
      dispatch,
    ),
)(PhoneCall)
